import { ReactElement } from "react";
import { appBody } from "../../Component/Layout/AppBody";
import { Globals } from "../Globals/GlobalObs";

export class Router{
    public static OpenMasterPage(props:{page:string , content:React.ComponentType}){
        Globals.sideBar.SelectedPage = props.page
        const ele:ReactElement = <props.content/>
        appBody.Element = ele
    }
    public static OpenNormalPage(ele:ReactElement){
        Globals.sideBar.SelectedPage = ''
        appBody.Element = ele
    }
}